import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiCall } from './../../components/special/apiCall';
import SimpleFileUploadButton from 'components/button/SimpleFileUploadButton';
import TextDate from './../../components/text/TextDate';
import TextAmount from 'components/text/TextAmount';
import {useErrorContext} from 'components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { LINClaimList } from './LINClaimList';
import { useLocale } from './../../components/special/LanguageProvider';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const LINFileImport = (props)  => {
  const [claimList, setClaimList] = useState([]);
  const [claimResult, setClaimResult] = useState(null);
  const [step, setStep] = useState(0);    
  const [fileStep1, setFileStep1] = useState(null);  
  const [fileStep2, setFileStep2] = useState(null);
  const { t } = useLocale();
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();

  
  
   const isResultOk = (obj) => {
        if ((obj != null) && (obj.error != undefined)){
            setCheckErrorItems([obj]);
            return null;
        }
        return obj;
    }


    const loadTextFile = async (file) => {        
        let dataForm = new FormData();
        dataForm.append('file', file);
        dataForm.append('name', file.name);
        const fileData = await apiCall(`${BASE_URL}/features/upload`,{data: dataForm, contentType: 'multipart/form-data', method: 'post'});
        if (isResultOk(fileData)){
            return fileData;
        }
        return null;
    }

    const loadStep1DataFromFile = async (file) => {
        setIsPageLoading(true);
        let loadedFile = await loadTextFile(file);
        if (loadedFile != null){            
            const dataFileResult = await apiCall(`${BASE_URL}/features/lin/mainfile`,{ method: 'post', data: loadedFile});
            if (isResultOk(dataFileResult)){                
                setFileStep1(loadedFile);
                setClaimList(dataFileResult);
            }
        }
        setIsPageLoading(false);
    };

    const loadStep2DataFromFile = async (file) => {        
        setIsPageLoading(true);
        let loadedFile = await loadTextFile(file);
        if (loadedFile != null){
            loadedFile.claimList = claimList;
            const dataFileResult = await apiCall(`${BASE_URL}/features/lin/debtorfile`,{ method: 'post', data: loadedFile});
            if (isResultOk(dataFileResult)){                
                setFileStep2(loadedFile);
                setClaimList(dataFileResult);
            }
        }
        setIsPageLoading(false);
    };


    const registerClaims = async () => {  
        setIsPageLoading(true);  
        let data = {
            claims : claimList
        };
        const createResult = await apiCall(`${BASE_URL}/features/lin/createclaims`,{ method: 'post', data: data});
        if (isResultOk(createResult)){            
            setClaimResult(createResult);
            setClaimList(null);
            gotoNextStep();                       
        }
        setIsPageLoading(false);
    }

    const startOver = () => {
        setIsPageLoading(true);  
        setClaimList(null);
        setFileStep1(null);
        setFileStep2(null);
        setStep(0);
        setIsPageLoading(false);  
    }

    const gotoNextStep = () => {
      setStep(step+1);
    }    

  return (
    <div>
      <h1 className="text-red text-32">{t("Lín skráar innlestur")}</h1>    
       
       {/* TODO -> Spinner */}
        {fileStep1 && 
       <div className="grid">
                <div className="col s1of1 text-right">
                    {(step < 4) && <button className="button clear gutter-right" onClick={startOver}>{t("Byrja aftur")}</button>}
                </div>
        </div>}                    

        {step === 0 && (
            <div className="grid box" id="skref1">
                <div className="col s1of1">
                    <div className="grid">
                        <div className="col s1of2">
                            <h3>{t("Aðalskrá")}</h3>
                        </div>
                        <div className="col s1of2 text-right">
                            <p>{t("Skref") + " 1 " + t("af") + " 3 "}</p>
                        </div>
                    </div>
                </div>
                <div className="col s1of1">
                    <div className="grid">
                        <div className="col s1of2">
                            <p>{t("Til að hlaða inn málum sem koma frá LÍN á skráarformi")}</p>
                            <p>{t("Dæmi um heiti á skrá \"Nýtt í lögfræðiinnheimtu frá LÍN xx.xx.xxxx.txt\"")}</p>
                            <p>{t("Athuga skal að engar kröfur eru stofnaðar í kerfinu fyrr en á lokaskrefinu. ")}</p>
                        </div>
                        <div className="col s1of2 text-right">
                            <div className="col s1of1">
                              <div className="grid">
                                <div className="col s1of1">
                                    {!fileStep1 && (<span>{t("Hlaða inn skrá")}</span>)}
                                    {fileStep1 && (<span>{t("Búið að hlaða inn skrá")}</span>)}
                                </div>
                                <div className="col s1of1">
                                {!fileStep1 && <SimpleFileUploadButton fileType=".txt" onSelectedFile={loadStep1DataFromFile} />}
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col s1of1 text-right">
                    {fileStep1 && <button className="button blue" onClick={gotoNextStep}>{t("Næsta skref")}</button>}
                </div>
            </div>
            )
        }
        {step === 1 && (
            <div className="grid box" id="skref2">
                <div className="col s1of1">
                    <div className="grid">
                        <div className="col s1of2">
                            <h3>{t("Ábyrgðarmaður")}</h3>
                        </div>
                        <div className="col s1of2 text-right">
                            <p>{t("Skref") + " 2 " + t("af") + " 3 "}</p>
                        </div>
                    </div>
                </div>
                <div className="col s1of1">
                    <div className="grid">
                        <div className="col s1of2">
                            <p>{t("Til að hlaða inn ábyrgðarmönnum og tengja þá við mál sem er búið að hlaða inn í frá aðalskrá.")}</p>
                            <p>{t("Dæmi um heiti á skrá \"Nýtt í lögfræðiinnheimtu frá LÍN xx.xx.xxx með ábm..txt\"")}</p>
                            <p>{t("Ef það er engin skrá fyrir ábyrgðarmenn er hægt að fara strax á næsta skref.")}</p>
                        </div>
                        <div className="col s1of2 text-right">
                            <div className="col s1of1">
                              <div className="grid">
                                <div className="col s1of1">
                                    {!fileStep2 && (<span>{t("Hlaða inn skrá")}</span>)}
                                    {fileStep2 && (<span>{t("Búið að hlaða inn skrá")}</span>)}
                                </div>
                                <div className="col s1of1">
                                    {!fileStep2 && <SimpleFileUploadButton fileType=".txt" onSelectedFile={loadStep2DataFromFile}/>}
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col s1of1 text-right">
                    <button className="button blue" onClick={gotoNextStep}>Næsta skref</button>
                </div>
            </div>
        )}
        {step === 2 && (
            <div className="grid box" id="skref3">
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <h3>{t("Kröfur")}</h3>
                    </div>
                    <div className="col s1of2 text-right">
                        <p>{t("Skref") + " 3 " + t("af") + " 3 "}</p>
                    </div>
                </div>
            </div>
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <p>{t("Þetta skref er til þess að stofna þær kröfur sem eru í listanum hér fyrir neðan.")}</p>
                        <p>{t("Athuga að þessi aðgerð getur tekið smá tíma.")}</p>
                    </div>
                    <div className="col s1of2 text-right">
                        
                    </div>
                </div>
            </div>
            <div className="col s1of1 text-right">
                <button className="button blue" onClick={registerClaims}>{t("Stofna kröfur")}</button>
            </div>
            </div>
        )}

        {step === 3 && (
            <div className="grid box" id="skref4">
                <div className="col s1of1 text-center">
                    <h3>{t("Kröfur hafa verið stofnaðar")}</h3>
                </div>                
                <div className="col s1of1 text-center">
                    <button className="button blue" onClick={startOver}>{t("Lokið")}</button>
                </div>
            </div>
        )}
        
        {claimList && claimList.length > 0 && <LINClaimList list={claimList} />} 

       {step === 3 && claimResult && (
           <div className="grid">
                <div className="col s1of1"> 
                    <h3>{t("Kröfur sem voru stofnaðar")}</h3>
                </div>
                <div className="col s1of1">                     
                    <LINClaimList list={claimResult.created} isClaimNumber={true} />
                </div>

                <div className="col s1of1"> 
                    <h3>{t("Færslur sem ekki var hægt að stofna kröfur")}</h3>
                </div>
                <div className="col s1of1">
                    <LINClaimList list={claimResult.notCreated} />
                </div>                
           </div>
       )}

        

    </div>
  );
};
